// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__RkVCa","fullContainer":"Loading_fullContainer__se7IO","fullLoading":"Loading_fullLoading__2Pubn"};